import React, { useCallback, useState } from "react";
import {
  DocumentData,
  DocumentSnapshot,
  QueryDocumentSnapshot,
} from "firebase/firestore";
import { Box, Pressable, Stack } from "native-base";
import Subsection from "../typo/Subsection";
import PhotoButton from "../shared/PhotoButton";
import {
  dragActiveStyle,
  useUploadPhotoToObject,
} from "../../hooks/useUploadPhotoToObject";
import { useOverviewMaps } from "../../hooks/useOverviewMaps.web";
import PhotoModal from "./capture/PhotoModal";
import PhotoThumbnail from "../shared/PhotoThumbnail";

type Props = {
  object: DocumentSnapshot<DocumentData>;
  updateObject: (data: any) => Promise<void>;
};

export default function OverviewMap({ object }: Props) {
  const [photoInModal, setPhotoInModal] = useState<
    QueryDocumentSnapshot<DocumentData> | undefined
  >(undefined);

  const onClose = useCallback(() => {
    setPhotoInModal(undefined);
  }, [setPhotoInModal]);

  const [uploadPhoto, isUploading, dropzone] = useUploadPhotoToObject(
    "overviewMap",
    object.ref.parent.parent!.id,
    object.id,
    undefined,
    1
  );

  const { getRootProps, isDragAccept } = dropzone;

  const [overviewMaps, isLoading] = useOverviewMaps(
    object.ref.parent.parent!.id,
    object.id
  );

  const overviewMap = overviewMaps && overviewMaps[0];

  return (
    <Stack space={4} mb={4}>
      <Subsection title="Übersichtskarte" />

      {!isLoading && (
        <Box w="400" h="300">
          {overviewMap ? (
            <Pressable
              onPress={() => {
                setPhotoInModal(overviewMap as any);
              }}
            >
              <PhotoThumbnail key={overviewMap.id} photo={overviewMap as any} />
            </Pressable>
          ) : (
            <div {...getRootProps()} style={dragActiveStyle(isDragAccept)}>
              <PhotoButton
                onPress={uploadPhoto}
                label="Übersichtskarte"
                isLoading={isUploading}
              />
            </div>
          )}
        </Box>
      )}

      <PhotoModal
        objectName="Übersichtskarte"
        photo={photoInModal}
        onClose={onClose}
      />
    </Stack>
  );
}
